import { IdentificationCheckComponent } from './container/identification-check/identification-check.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { LoginEffects } from './effects/login.effects';
import { RegisterEffects } from './effects/register.effects';
import { LoginConfirmEffects } from './effects/login-confirm.effects';
import { ResendOtpEffects } from './effects/resend-otp.effects';
import { OtpComponent } from './container/otp/otp.component';
import { AuthRoutingModule } from './auth-routing.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { PasscodeComponent } from './container/passcode/passcode.component';
import { LandingComponent } from '../landing/landing.component';
import { FormControl, FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { MarketingOptionsComponent } from './container/marketing-options/marketing-options.component';
import { CheckIfRegisteredEffects } from './effects/check-if-registered.effects';
import { ValidateMobileNumberEffects } from './effects/validate-mobile-number.effects';
import { MobileValidationComponent } from './container/mobile-validation-component/mobile-validation.component';
import { ForgotPasscodeEffects } from './effects/forgot-passcode.effects';
import { ForgotPasscodeComponent } from './container/forgot-passcode/forgot-passcode.component';
import { ForgotPasscodeOtpComponent } from './container/forgot-passcode-otp/forgot-passcode-otp.component';
import { StoreModule } from '@ngrx/store';
import * as fromAuthReducer from './auth.reducer';
import { LogoutEffects } from './effects/logout.effects';
import { NewUserPasscodeEffects } from './effects/new-user-passcode.effects';
import { ValidateGivIdPassportEffects } from './effects/validate-giv-id-passport.effects';
import { ForgotPasscodeVerifyEffects } from './effects/forgot-passcode-verify.effects';
import { ForgotPasscodeLoginConfirmEffects } from './effects/forgot-passcode-login-confirm.effects';
import { ForgotPasscodeResendOtpEffects } from './effects/forgot-passcode-resend-otp.effects';
import { MarketingOptionsEffects } from './effects/marketing-options.effects';
import { SignupEffects } from './effects/signup.effects';
import { SignupComponent } from './container/signup/signup.component';
import { GeneralLinkComponent } from './container/general-link/general-link.component';
import { SignupSetPasscodeEffects } from './effects/signup-set-passcode.effects';
import { SwitchToAnotherBusinessProfileEffects } from './effects/switch-to-another-business-profile.effects';
import { MarketingComponent } from './components/marketing/marketing.component';
import { RegulatoryComponent } from './components/regulatory/regulatory.component';
import { BusinessUserRoleEffects } from './effects/business-user-role.effects';
import { ValidateTokenEffects } from './effects/validate-token.effects';

import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { RefreshTokenEffects } from './effects/refresh-token.effects';
import 'intl-tel-input/build/js/utils';
import { MobileSubmitComponent } from './container/mobile-submit/mobile-submit.component';
import { VerifyEmailEffects } from './effects/verify-email.effects';
import { LocalDevExtremeModule } from '../../dev-extreme/dev-extreme.module';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    LandingComponent,
    OtpComponent,
    PasscodeComponent,
    IdentificationCheckComponent,
    MarketingOptionsComponent,
    MobileValidationComponent,
    MobileSubmitComponent,
    ForgotPasscodeComponent,
    ForgotPasscodeOtpComponent,
    SignupComponent,
    GeneralLinkComponent,
    MarketingComponent,
    RegulatoryComponent
  ],
  imports: [
    FormsModule,
    NgOtpInputModule,
    AuthRoutingModule,
    CommonModule,
    LocalDevExtremeModule,
    SharedModule,
    ReactiveFormsModule,
    // PrimengModule,
    LottieModule.forRoot({ player: playerFactory }),
    StoreModule.forFeature(fromAuthReducer.authFeatureKey, fromAuthReducer.reducers),
    EffectsModule.forFeature([
      LoginEffects,
      RegisterEffects,
      LoginConfirmEffects,
      ForgotPasscodeEffects,
      ResendOtpEffects,
      CheckIfRegisteredEffects,
      ValidateMobileNumberEffects,
      ForgotPasscodeEffects,
      LogoutEffects,
      NewUserPasscodeEffects,
      ValidateGivIdPassportEffects,
      ForgotPasscodeVerifyEffects,
      ForgotPasscodeLoginConfirmEffects,
      ForgotPasscodeResendOtpEffects,
      MarketingOptionsEffects,
      SignupEffects,
      VerifyEmailEffects,
      SignupSetPasscodeEffects,
      SwitchToAnotherBusinessProfileEffects,
      BusinessUserRoleEffects,
      ValidateTokenEffects,
      RefreshTokenEffects
    ])
  ]
})
export class AuthModule {}
